module.exports = __webpack_public_path__ + "static/media/HeroImage_Spendwise.fab69b4d.png";